import { gql } from '../__generated__';

export const RECENTLY_CLAIMED_COMPANIES = gql(`
  query RecentlyClaimedCompanies(
    $limit: Int
    $offset: Int
    $order: CompaniesRecentlyClaimedOrder
  ) {
    companiesRecentlyClaimed(limit: $limit, offset: $offset, order: $order) {
      total
      collection {
        company {
          ...CompanyData
        }
      }
    }
  }
`);
